// FFL license status for dealer contacts. Shared by the Contacts page
// and ContactSelect so the two surfaces can never disagree.
import { parseDate } from './utils';

export function getFflStatus(contact) {
  if (contact?.type !== 'DEALER') return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const raw = contact.ffl_expiration_date;
  if (!raw) {
    return { level: 'expired', message: 'No FFL expiration date on file' };
  }
  const exp = parseDate(raw);
  exp.setHours(0, 0, 0, 0);
  const days = Math.round((exp - today) / 86400000);
  const formatted = exp.toLocaleDateString();
  if (days < 0) return { level: 'expired', message: `FFL expired on ${formatted}` };
  if (days <= 30) return { level: 'warning', message: `FFL expires in ${days} day${days === 1 ? '' : 's'} (${formatted})` };
  return { level: 'ok', message: `FFL valid until ${formatted}` };
}
